<template>
	<div class="notifications container page">
		<h1 class="notifications__title">Уведомления</h1>
		<div class="notifications__actions">
			<button
				class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
				@click="markAllAsRead()"
			>
				Прочитать все
			</button>
		</div>
		<div class="table-container">
			<table>
				<thead>
					<tr>
						<th>Организация</th>
						<th>Наименование</th>
						<th>Вид отчетности</th>
						<th>От кого</th>
						<th>Дата получения</th>
						<th>Статус</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="notification in notificationsList"
						:key="notification.id"
						@click="openReport(notification)"
					>
						<td>{{ notification.from_user.ouser.kmg_dzo.name }}</td>
						<td>{{ notification.name }}</td>
						<td>{{ notification.reportName }}</td>
						<td>
							{{ notification.from_user.last_name }}
							{{ notification.from_user.first_name }}
						</td>
						<td>
							{{ notification.created_datetime | formatDate }}
						</td>
						<td :class="getColor(notification.status)">
							{{ notification.status }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="notifications__pagination">
			<pagination v-if="this.pageCount > 1" :currentPage="this.page" :pageCount="this.pageCount" @pageClicked="search" />
		</div>
	</div>
</template>

<script>
import store from '../store';
import NProgress from 'nprogress';
import { mapGetters } from 'vuex';
import Pagination from '../components/shared/Pagination.vue';

export default {
	name: 'Notification',
	components: {
		Pagination
	},
	data() {
		return {
			notifications: '',
			page: 1
		};
	},
	beforeRouteEnter(to, from, next) {
		NProgress.start();
		store.dispatch('getNotifications', 1)
			.then(() => {
				NProgress.done();
				next();
			});
	},
	methods: {
		markAllAsRead() {
			store.dispatch('markAllAsRead').then(() => {
				this.$router.go()
			})
		},
		reportType() {},
		openReport(notification) {
			if (notification.report !== null) {
				this.$router.push({
					name: 'view-report-item',
					params: { id: notification.report },
				});
			} else if (notification.tmz_report !== null) {
				this.$router.push({
					name: 'view-tmz-step-first',
					params: { id: notification.tmz_report },
				});
			}
		},
		getColor(status) {
			if (status === 'Новый') {
				return 'status-red';
			} else {
				return 'status-green';
			}
		},
		search (page = 1) {
			NProgress.start();
			store.dispatch('getNotifications', page)
				.then(() => {
					NProgress.done();
				});
		},
	},
	computed: {
		...mapGetters(['notificationsList', 'notificationsListCount']),
		pageCount() {
			return Math.ceil(this.notificationsListCount / 10)
		}
	}
};
</script>

<style scoped>
.page {
	padding: 2rem 0;
}

.notifications__title {
  text-align: center;
  margin: 1rem 0 1.5rem;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
}

.notifications__actions {
	display: flex;
	justify-content: end;
	margin: 1rem 0;
}

.notifications__actions button {
	height: 40px;
}

.table-container {
	display: flex;
	justify-content: center;
}

table {
	border-collapse: collapse;
	width: 100%;
	max-width: 1460px;
	padding: 1rem;
}

thead {
	background: #f3f5ff;
	height: 70px;
}

thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

thead th:last-child {
	border-top-right-radius: 10px;
}

th {
	padding: 1rem;
	color: #565656;
}

tr {
	cursor: pointer;
}

tr:hover {
	background: #f3f5ff;
}

td {
	padding: 1rem;
	text-align: center;
	border: 1px solid #e3e3e3;
}

.my-report-status {
	/* background: #7AD38D; */
	padding: 0.5rem 2.5rem;
	border-radius: 5px;
	/* width: 180px; */
}

.status-green {
	background: #7ad38d;
	color: white;
}

.status-yellow {
	background: #ffbb56;
	color: white;
}

.status-red {
	background: #e86363;
	color: white;
}

.notifications__pagination {
	margin-top: 1.5rem;
}
</style>
